// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LatestNews_wrapper__MasF0","title-container":"LatestNews_title-container__2cI6c"};